import React from 'react';

const SearchIcon = ({ size = 22, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 18 19'
    fill='currentColor'
    {...props}>
    <path d='M16.9356 8.61056C17.4394 6.30149 16.987 4.12461 15.6636 2.47947C14.3754 0.881327 12.4262 0 10.1744 0C7.92257 0 5.72219 0.849012 3.84496 2.39133C1.97214 3.92778 0.678063 5.98127 0.200678 8.17284C-0.303147 10.4819 0.149267 12.6603 1.47273 14.3039C2.76093 15.9035 4.71013 16.7834 6.96192 16.7834C8.84503 16.7834 10.759 16.165 12.4467 15.0237L15.098 18.4124L16.6874 17.108L14.039 13.7223C14.6559 13.12 15.192 12.4561 15.6371 11.7481C16.254 10.7683 16.6962 9.70782 16.9356 8.61056ZM14.9276 8.17284C14.1389 11.7877 10.5666 14.727 6.96192 14.727C5.34469 14.727 3.96541 14.1189 3.07527 13.0143C2.14841 11.8641 1.84142 10.2998 2.20863 8.61056C2.99742 4.99712 6.56973 2.05643 10.1744 2.05643C11.7916 2.05643 13.1723 2.66601 14.061 3.77061C14.7323 4.60346 15.0789 5.65371 15.0789 6.81266C15.0789 7.25185 15.029 7.7072 14.9276 8.17284Z' />
  </svg>
);

export default SearchIcon;
